import { render, staticRenderFns } from "./untactAddPage.vue?vue&type=template&id=72899988&scoped=true&"
import script from "./untactAddPage.vue?vue&type=script&lang=js&"
export * from "./untactAddPage.vue?vue&type=script&lang=js&"
import style0 from "./untactAddPage.vue?vue&type=style&index=0&id=72899988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72899988",
  null
  
)

export default component.exports